/**
 * Gemeinsame Cache-Invalidierung der Akte: nach jeder Datei-Mutation müssen der Datei-Baum sowie
 * die abgeleiteten Verträge-/Lieferanten-Listen neu geladen werden. Einzige Quelle für diese
 * Query-Keys (früher pro Mutations-Hook dupliziert).
 */
import type { QueryClient } from '@tanstack/react-query';

export function invalidatePropertyFiles(qc: QueryClient, propertyId: string): void {
  void qc.invalidateQueries({ queryKey: ['propertyFiles'] });
  void qc.invalidateQueries({ queryKey: ['contracts', propertyId] });
  void qc.invalidateQueries({ queryKey: ['supplierInvoices', propertyId] });
}
